import AppBuilder from 'app/developer-v3/components/AppBuilder';
import ContactPage from 'app/developer-v3/pages/contact';
import Developer from 'app/developer-v3/components/Developer';
import DeveloperV3Reducer from 'app/developer-v3/reducer';
import LegacyReducer from 'app/developer-v3/legacy/reducer';

import asyncRoutes from './asyncRoutes';

const Routes = {
  component: Developer,
  isAuthRequired: false,
  routes: {
    '.': asyncRoutes.home,
    // TODO: Create and use asyncRoutes.contact.
    contact: {
      isAuthRequired: false,
      component: ContactPage,
      routes: {
        '.': asyncRoutes.contact,
      },
    },
    ['partner-settings']: asyncRoutes.partnerSettings,
    // TODO: Create and use asyncRoutes.invite.
    invite: {
      isAuthRequired: true,
      routes: {
        app: {
          routes: {
            ':id': {
              routes: {
                '.': asyncRoutes.home,
                ':role': asyncRoutes.home,
              },
            },
          },
        },
      },
    },
    'join-integration': asyncRoutes.joinIntegration,
    app: {
      isAuthRequired: true,
      routes: {
        new: asyncRoutes.createIntegration,
        ':id': {
          assign: ({ params }) => ({
            params: {
              ...params,
              // TODO: remove this field and honor params.id as a string. appId
              // is an unnecessary artifact. When we need a number of the id,
              // which should be rare, just use Number(params.id) on the
              // consumer side.
              appId: parseInt(params.id, 10),
            },
          }),
          component: AppBuilder,
          routes: {
            '.': asyncRoutes.dashboard,
            'automatic-account-creation': asyncRoutes.automaticAccountCreation,
            history: asyncRoutes.history,
            issues: asyncRoutes.issues,
            monitoring: asyncRoutes.monitoring,
            sharing: asyncRoutes.sharing,
            publishing: asyncRoutes.publishing,
            team: asyncRoutes.team,
            embed: asyncRoutes.embed,
            'embed-settings': asyncRoutes.embedSettings,
            'embed-zap-editor': asyncRoutes.embedZapEditor,
            insights: asyncRoutes.insights,
            'prefilled-zaps': asyncRoutes.prefilledZaps,
            version: {
              routes: {
                ':version': {
                  routes: {
                    '.': asyncRoutes.versionOverview,
                    actions: asyncRoutes.actions,
                    advanced: asyncRoutes.advanced,
                    authentication: asyncRoutes.authentication,
                    home: {
                      onEnter({ routeTo, router }) {
                        routeTo(
                          router.next.location.pathname.replace(
                            new RegExp(`/home/?$`),
                            ''
                          )
                        );
                      },
                    },
                    settings: {
                      onEnter({ routeTo, router }) {
                        routeTo(
                          router.next.location.pathname.replace(
                            new RegExp(
                              `/version/${router.next.params.version}`
                            ),
                            ''
                          )
                        );
                      },
                    },
                    triggers: asyncRoutes.triggers,
                  },
                },
              },
            },
            settings: asyncRoutes.settings,
            versions: asyncRoutes.versions,
            visibility: {
              onEnter({ routeTo, router }) {
                routeTo(
                  router.next.location.pathname.replace(
                    new RegExp(`/visibility(?=[/?])?`),
                    '/share-publish'
                  )
                );
              },
            },
            'workflow-api': asyncRoutes.workflowAPI,
            'workflow-element': asyncRoutes.workflowElement,
          },
        },
      },
    },
  },
  app: {
    reducers: {
      developerV3: DeveloperV3Reducer,
      // Needed for Manage Team page until it gets moved over to developer-v3.
      developer: LegacyReducer,
    },
  },
};

export default Routes;
